import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@sm360/ui-library';
import { Vehicle, Quote } from '@sm360/widget-commons-vehicle';
import { SessionStorageService } from '@sm360/widget-commons-general';
import InstantEstimateWrapper from 'trade-in-360/components/InstantEstimateWrapper/InstantEstimateWrapper.jsx';
import ConfirmationModal from 'trade-in-360/components/ConfirmationModal/ConfirmationModal.jsx';
import 'trade-in-360/components/InstantEstimateModal/InstantEstimateModal.scss';

const InstantEstimateModal = ({
    onClose,
    openModal,
    tradeInVehicle,
    isShowroomV2Enabled,
    quote,
    isLoginModalOpen,
    isTrade360,
    onTradeInSuccess,
    appointmentEnabled,
    config,
    isMultiDealerTradeIn,
    websiteDomain,
    standAlone,
}) => {
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [configData, setConfigData] = useState(config);
    const [sessionUserGeoData, setUserGeoData] = useState({});
    useEffect(
        () => {
            // Flag to use for Marketplace standalone tradeIn where need to trace the user selected location from session data
            if (isMultiDealerTradeIn) {
                const userLocationSessionData = SessionStorageService?.get('currentLocationData');
                const {
                    stateCode: sessionOrgUnitLocation,
                    latitude: sessionUserLatitude,
                    longitude: sessionUserLongitude,
                } =
                    userLocationSessionData || {};
                const updatedConfig = { ...configData, location: sessionOrgUnitLocation || configData.location };
                setConfigData(updatedConfig);
                setUserGeoData({ sessionUserLatitude, sessionUserLongitude });
            }
        },
        [openModal]
    );

    const handleCloseModal = ({ confirm, setClose }) => {
        if (confirm) setConfirmModalOpen(true);
        else {
            setClose();
            if (typeof onClose === 'function') onClose();
        }
    };

    const modalClassnames = `widget-sr makes__honda crm crm-modal ${isTrade360 ? 'trade-360-modal' : ''}`;

    return (
        <Modal
            isModalOpen={openModal}
            modalScopeCSS={isLoginModalOpen ? 'login-process' : ''}
            className={modalClassnames}
        >
            {({ setClose }) => (
                <>
                    <InstantEstimateWrapper
                        tradeInVehicle={tradeInVehicle}
                        isShowroomV2Enabled={isShowroomV2Enabled}
                        quote={quote}
                        closeModal={({ confirm }) => handleCloseModal({ confirm, setClose })}
                        isModal
                        onTradeInSuccess={onTradeInSuccess}
                        appointmentEnabled={appointmentEnabled}
                        config={configData}
                        isMultiDealerTradeIn={isMultiDealerTradeIn}
                        websiteDomain={websiteDomain}
                        sessionUserGeoData={sessionUserGeoData}
                        standAlone={standAlone}
                    />
                    <ConfirmationModal
                        isOpen={confirmModalOpen}
                        onCancel={() => setConfirmModalOpen(false)}
                        onConfirm={() => {
                            setConfirmModalOpen(false);
                            setClose();
                            if (typeof onClose === 'function') onClose();
                        }}
                    />
                </>
            )}
        </Modal>
    );
};

InstantEstimateModal.defaultProps = {
    openModal: false,
    isTrade360: false,
    config: {},
    isMultiDealerTradeIn: false,
    websiteDomain: '',
    standAlone: false,
};

InstantEstimateModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    openModal: PropTypes.bool,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
    isTrade360: PropTypes.bool,
    onTradeInSuccess: PropTypes.func.isRequired,
    appointmentEnabled: PropTypes.bool.isRequired,
    config: PropTypes.object,
    isMultiDealerTradeIn: PropTypes.bool,
    websiteDomain: PropTypes.string,
    standAlone: PropTypes.bool,
};

InstantEstimateModal.displayName = 'InstantEstimateModal';
export default InstantEstimateModal;
